<template>
  <div>
    <div class="d-flex justify-content-between my-3">
      <h4>{{ $t('Opening Hours') }}</h4>
    </div>
    <StoreSlotConfig
      :times-data="openingHours"
      input-name="opening_hours"
      @time-changed="openingHours = $event"
    >
    </StoreSlotConfig>

    <div class="d-flex justify-content-between my-3">
      <h4>{{ $t('Booking Slot Times') }}</h4>
      <button @click.prevent="onUseOpeningHoursClick"
              class="btn btn-outline-primary btn-sm">
        <i class="fa fa-clone" style="width: 25px"></i>
        {{ $t('Opening Hours') }}
      </button>
    </div>
    <StoreSlotConfig
      :times-data="bookingSlots"
      input-name="booking_slots"
      @time-changed="bookingSlots = $event"
    >
    </StoreSlotConfig>
  </div>
</template>

<script setup>
import { defineProps, onMounted, ref } from "vue";
import StoreSlotConfig from "@/components/store/StoreSlotConfig.vue";
import { DAYS } from "@/utils/date";

const props = defineProps({
  openingHours: {
    type: Object,
    default: () => {}
  },
  bookingSlots: {
    type: Object,
    default: () => {}
  }
});

const formatHours = (timesData) => {
  return DAYS.map((day) => {
    if (!timesData?.[day]) {
      return ["", ""];
    }
    return timesData[day].length === 0 ? ["", ""] : timesData[day];
  }).reduce((accumulator, value, index) => {
    accumulator[DAYS[index]] = value;
    return accumulator;
  }, {});
}


const openingHours = ref(formatHours(props.openingHours));
const bookingSlots = ref(formatHours(props.bookingSlots));


function onUseOpeningHoursClick() {
  bookingSlots.value = { ...openingHours.value };
}

</script>

<style scoped>

</style>
